import type { AppointmentsFeatureConfig } from './type';

export const appointments: Partial<AppointmentsFeatureConfig> = {
    showHomeBranch: false,
    timeslotsIntervalInDays: 32,
    maxDescriptionLength: 100,
    showDataProcessingLegalDisclaimer: true,
    invalidateCacheAfterCancelingAppointment: true,
};
